import Divider from "@/common/components/Divider";
import ExamSetupBlock from "./ExamSetupBlock";
import SettingsBlock from "./SettingsBlock";
import DocumentsBlock from "./DocumentsBlock";

/** EN-1249: the AVImark hub inside the Settings › Integrations card, HappyBridge AVImark only. */
export default function AvimarkHub() {
    return (
        <>
            <Divider />
            <ExamSetupBlock />
            <Divider />
            <SettingsBlock />
            <Divider />
            <DocumentsBlock />
        </>
    );
}
